module.exports = __webpack_public_path__ + "1df894121f108e49d44ae990deb6dd79.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/settings_folder.png
// module id = 85
// module chunks = 0 1 2 3 4